export default [
  {
    naoNulo: true,
    tipo: 'data',
    atributo: 'data',
    nome: 'Data',
  },
  { naoNulo: true, tipo: 'string', atributo: 'motivo', nome: 'Motivo' },
];
